import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, OccConfig, TranslationService, } from '@spartacus/core';
import { ImportOrderService } from 'src/app/services/feature/importOrder/import-order.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-kb-importorder',
  templateUrl: './kb-importorder.component.html',
  styleUrls: ['./kb-importorder.component.scss'],
  standalone: false
})
export class KbImportorderComponent {
  private unsubscribe$ = new Subject<void>();
  entry: any;
  cartId;
  orderType;
  baseUrl = this.config?.backend?.occ?.baseUrl + '/';
  mediaUrl;
  error: boolean = false;
  isUploading: boolean = false;
  destroy$: any;
  errorArray: any;
  dateFormatKey: string = 'common.import_csv_savedCart_requestedDate';
  dateFormat: string = '';
  @ViewChild('fileInput') fileInput: ElementRef;

  subheadlineKey = 'common.import_csv_savedCart_filesNote';

  constructor(private service: ImportOrderService,
    private Activecart: ActiveCartFacade,
    private globalmsgService: GlobalMessageService,
    public cdr: ChangeDetectorRef,
    private translationservice: TranslationService,
    private custIdService: CustomerIdService,
    private config: OccConfig) { }

  ngOnInit() {
    this.custIdService.currentCustId.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe((x) => {
      this.error = false;
      this.Activecart.getActiveCartId().pipe(takeUntil(this.unsubscribe$)).subscribe((x) => {
        if (x) {
          this.cartId = x;
          this.service.getApi(x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            this.entry = data;
            this.mediaUrl = data?.['mediaUrl'];
            this.translationservice.translate(this.dateFormatKey).pipe(takeUntil(this.unsubscribe$)).subscribe((transLatedValue: string) => {
              const value = transLatedValue.split('{');
              this.dateFormat = value[0] + data.dateFormat + ')';
            });
            this.orderType = data?.currentOrderTypeImport;
            this.cdr.detectChanges();
          });
        }
      });
    });
  }

  onFileSelected(event: any): void {
    const selectedFile = event.files[0];
    if (selectedFile) {
      this.error = false;
      const formData = new FormData();
      formData.append('csvFile', selectedFile);
      if (this.orderType == undefined) {
        const key = 'common.please_enter_order_type_text';
        this.globalmsgService.add({ key: key }, GlobalMessageType.MSG_TYPE_ERROR);
        event.value = '';
      } else {
        this.service.postApi(formData, this.orderType, this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((x: any) => {
          if (x?.errorMessages && x?.errorMessages.length > 0) {
            this.errorArray = x?.['errorMessages'];
            this.error = true;
            event.value = '';
            this.isUploading = false;
            this.Activecart.reloadActiveCart();
            this.cdr.detectChanges();
          }
          else if (x?.['message']['status'] == 'SUCCESS') {
            const key = 'common.import_csv_savedCart_success';
            this.globalmsgService.add({ key: key }, GlobalMessageType.MSG_TYPE_INFO);
            event.value = '';
            this.isUploading = false;
            this.Activecart.reloadActiveCart();
            this.cdr.detectChanges();
          } else if (x?.['message']['status'] == 'ERROR') {
            this.globalmsgService.add({ key: x?.['message']['message'] }, GlobalMessageType.MSG_TYPE_ERROR);
            event.value = '';
            this.isUploading = false;
          }
        },
          (error) => {
            event.value = '';
            this.isUploading = false;
          });
      }
    }
  }

  onDropdownChange(value: string) {
    this.orderType = value;
    if (this.orderType !== undefined) {
      this.service.getOrderType(this.orderType, this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((x: any) => {
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
